import React, { useState } from "react";
import { Dialog, IconButton, Typography, makeStyles } from "@material-ui/core";
import Apikey from "../pages/conference/apikey/apikey";
import Invite from "../pages/conference/Invite/invite";
import CreateConference from "../pages/conference/create/create";
import PlaylistAddCheckOutlinedIcon from "@material-ui/icons/ViewList";
import CodeIcon from '@material-ui/icons/Code';
import VpnKeyOutlinedIcon from "@material-ui/icons/VpnKey";
import List from "../pages/conference/List/list";
import Translation from "../pages/conference/translation/translation";
import Conference_room from "../assets/conference-room-Icon.svg";
import PropTypes from "prop-types";
import Constant from "../helper/constant.json";

const useStyles = makeStyles({
  dialog: {
    position: "absolute",
    right: 10,
    bottom: 50,
    top: 10,
  },
  popUp: {
    position: "absolute",
    bottom: 3,
    right: 3,
  },
});

function Popups({ sip, makeCall }) {
  const [dailog, setDailog] = useState(false);
  const [list, setList] = useState(false);
  const [ComponentName, setComponentname] = useState("");
  const classes = useStyles();

  return (
    <>
      <div style={{ width: "12em" }}>
        <div
          style={{ display: "flex", flexDirection: "row" }}
          onClick={() => {
            setDailog(true);
            setComponentname("conference");
          }}
        >
          <IconButton>
            <img width="23px" height="23px" src={Conference_room} />
          </IconButton>
          <Typography style={{ marginTop: "12px" }}>Create Room</Typography>
        </div>
        <div
          style={{ display: "flex", flexDirection: "row" }}
          onClick={() => {
            setList(true);
            setComponentname("list");
          }}
        >
          <IconButton>
            <PlaylistAddCheckOutlinedIcon />
          </IconButton>
          <Typography style={{ marginTop: "12px" }}>Room List</Typography>
        </div>
        <div
          style={{ display: "flex", flexDirection: "row" }}
          onClick={() => {
            setDailog(true);
            setComponentname("ApiKey");
          }}
        >
          <IconButton>
            <VpnKeyOutlinedIcon />
          </IconButton>
          <Typography style={{ marginTop: "12px" }}>
            Account Settings
          </Typography>
        </div>
        <div
          style={{ display: "flex", flexDirection: "row" }}
          onClick={() => {
            setList(true);
            setComponentname("translation");
          }}
        >
          <IconButton>
            <CodeIcon />
          </IconButton>
          <Typography style={{ marginTop: "12px" }}>
            {Constant.CustomHeaders}
          </Typography>
        </div>
      </div>
      <Dialog
        onClose={() => {
          setDailog(false);
        }}
        aria-labelledby="simple-dialog-title"
        open={dailog}
        style={{
          backdropFilter: "blur(10px)",
        }}
      >
        {ComponentName === "conference" ? (
          <CreateConference setDailog={setDailog} />
        ) : ComponentName === "invite" ? (
          <Invite setDailog={setDailog} />
        ) : (
          <Apikey setDailog={setDailog} />
        )}
      </Dialog>
      <Dialog
        classes={{
          paper: classes.dialog,
        }}
        onClose={() => {
          setList(false);
        }}
        style={{
          backdropFilter: "blur(10px)",
          paddingTop: "50px",
        }}
        aria-labelledby="simple-dialog-title"
        open={list}
      >
        {ComponentName === "list" ? (
          <List setList={setList} sip={sip} makeCall={makeCall} />
        ) : ComponentName === "translation" ? (
          <Translation setList={setList} sip={sip} makeCall={makeCall} />
        ) : null}
      </Dialog>
    </>
  );
}
Popups.propTypes = {
  sip: PropTypes.any,
  makeCall: PropTypes.any,
};
export default Popups;
